const POLICIES = {
  TERMS_AND_CONDITIONS:
    'https://media.apexinvest.io/media/policies/TermsAndConditions.pdf',
  SUBSCRIPTION_AGREEMENT:
    'https://media.apexinvest.io/media/policies/SubscriptionAgreement.pdf',
  PRIVACY_POLICY:
    'https://media.apexinvest.io/media/policies/PrivacyPolicy.pdf',
  TERMS_OF_USE: 'https://media.apexinvest.io/media/policies/TermsofUse.pdf',
}

export default POLICIES
